"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER = void 0;
const vue_1 = __importDefault(require("vue"));
const z = __importStar(require("zod"));
const types_1 = require("./types");
const cell_editor_1 = require("./cell-editor");
const cell_formatter_1 = require("./cell-formatter");
const NUMBER_FORMATTER_CONFIG = types_1.BASE_CONFIG.extend({
    thousandSeparated: z.boolean().default(true),
    decimals: z.union([z.number(), z.null()]).optional(),
    minDecimals: z.union([z.number(), z.null()]).optional()
});
const NUMBER_EDITOR_CONFIG = types_1.BASE_CONFIG.extend({
    step: z
        .union([z.literal('any'), z.number()])
        .optional()
        .default('any'),
    decimals: z.union([z.number(), z.null()]).optional(),
    minDecimals: z.union([z.number(), z.null()]).optional()
});
exports.NUMBER = {
    name: 'number',
    formatter: {
        schema: NUMBER_FORMATTER_CONFIG,
        createComponent(config) {
            return {
                minWidth: 55,
                component: {
                    name: 'NumberFormatter',
                    mixins: [cell_formatter_1.CellFormatter],
                    ...vue_1.default.compile(`<span class="text-nowrap">{{ value|number({ decimals: ${config.decimals}, minDecimals: ${config.minDecimals} }) }}</span>`)
                }
            };
        }
    },
    editor: {
        schema: NUMBER_EDITOR_CONFIG,
        createComponent(config) {
            const validators = {};
            if (config.step === 'any') {
                validators['double'] = true;
            }
            else if (config.step === 1) {
                validators['integer'] = true;
            }
            return {
                minWidth: 55,
                textAlign: 'right',
                validators,
                component: {
                    name: 'NumberEditor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<b-form-input
              type="number"
              v-model="currentValue"
              v-bind="bindings"
              no-wheel
              inputmode="decimal"
              number
              :id="col.field"
              :name="col.name"
              :form="formId"
              :tabindex="col.effectiveTabindex"
              :size="col.size"
              :state="validationState"
              :disabled="isDisabled"
              @change="onChange($event)"
            ></b-form-input>`),
                    data() {
                        return {
                            bindings: {
                                step: config.step
                            }
                        };
                    }
                }
            };
        }
    }
};
//# sourceMappingURL=number.js.map